import { Component } from "react";
import "react-dropdown/style.css";
import { GetLeagueSelectorButtonTextHelper } from "../../helpers/GetLeagueSelectorButtonTextHelper/GetLeagueSelectorButtonTextHelper";
//
type Props = {
  props: Record<string, any>;
  toggleLeaguesSelector: (...args: Array<any>) => any;
  disabled: boolean;
};

class Leagues extends Component<Props> {
  render() {
    const { props, toggleLeaguesSelector, disabled } = this.props;
    return (
      <div className="global-event-navigation--leagues">
        <button
          className={`leagues-button ${
            props.bookmarkOnly || props.favouritesOnly || disabled
              ? "disabled"
              : ""
          }`}
          onClick={e => toggleLeaguesSelector(e)}
        >
          {GetLeagueSelectorButtonTextHelper.getLeagueSelectorButtonText(props)}
        </button>
      </div>
    );
  }
}

export default Leagues;
